import { render, staticRenderFns } from "./LoginFormPops.vue?vue&type=template&id=66f029a0"
import script from "./LoginFormPops.vue?vue&type=script&lang=js"
export * from "./LoginFormPops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports